<template>
  <ul v-if="paginator.hasPages" class="pagination" role="list">
    <!-- Previous Page Link -->
    <li v-if="!paginator.onFirstPage" class="pagination__item">
      <a class="pagination__link" :href="getUrl(paginator.currentPage - 1)" rel="prev" aria-label="Previous page">
        <i class="pagination__prev-icon"></i> Previous
      </a>
    </li>

    <li
      v-if="paginator.currentPage > 2"
      class="pagination__item d-none d-lg-inline-block"
    >
      <a class="pagination__link" :href="getUrl(1)">1</a>
    </li>

    <li
      v-if="paginator.currentPage > 3"
      class="pagination__item d-none d-lg-inline-block"
    >
      <span class="pagination__link">...</span>
    </li>

    <!-- Pagination Elements -->
    <li
      v-for="pageNo in pages"
      class="pagination__item"
      :class="{ 'active': pageNo === paginator.currentPage }"
      :key="pageNo"
      v-show="pageNo >= paginator.currentPage - 1 && pageNo <= paginator.currentPage + 1"
    >
      <a v-if="pageNo !== paginator.currentPage" class="pagination__link" :href="getUrl(pageNo)">{{ pageNo }}</a>
      <span v-else class="pagination__link">{{ pageNo }}</span>
    </li>

    <li
      v-if="paginator.currentPage === 1 && paginator.lastPage > 2"
      class="pagination__item">
      <a class="pagination__link" :href="getUrl(3)">3</a>
    </li>

    <li class="pagination__item d-none d-lg-inline-block" v-if="paginator.currentPage < paginator.lastPage - 2">
      <span class="pagination__link">...</span>
    </li>
    <li class="pagination__item d-none d-lg-inline-block"  v-if="paginator.currentPage < paginator.lastPage - 2">
      <a class="pagination__link" :href="getUrl(paginator.lastPage)">{{ paginator.lastPage }}</a>
    </li>

    <!-- Next Page Link -->
    <li v-if="paginator.hasMorePages" class="pagination__item">
      <a class="pagination__link" :href="getUrl(paginator.currentPage + 1)" rel="next" aria-label="Next page">
        Next <i class="pagination__next-icon"></i>
      </a>
    </li>
    <!-- Dummy list item that only renders when no other list items are present -->
    <li v-if="!paginator.onFirstPage && paginator.currentPage <= 2 && paginator.currentPage >= paginator.lastPage - 2" style="display: none;"></li>
  </ul>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  paginator: {
    type: Object,
    required: true
  }
});

const getUrl = (page) => {
  const url = new URL(window.location.href);
  url.searchParams.set('page', page);

  return url.toString();
};

const pages = computed(() => {
  let pages = [];
  for (let i = 1; i <= props.paginator.lastPage; i++) {
    pages.push(i);
  }
  return pages;
});
</script>
